export default __webpack_public_path__ + "static/media/1410.db9f2e86.png";